import React from 'react';
import './AssistStrip.css';

/**
 * The graded help menu, shown in place of the controls row.
 *
 * Before this the only help was a flag button that filled in the entire
 * solution and ended the puzzle — a cliff, and a brutal one for a new player
 * on their first day. These are the rungs below it: each still counts as a
 * solve, each costs time, and each states its cost up front.
 *
 * Give-up is the last item rather than a separate control, because it is the
 * bottom of this same ladder.
 */
const AssistStrip = ({
  costs,
  canRevealTile,
  onCheck,
  onRevealTile,
  onRevealAnswer,
  onGiveUp,
  onClose,
}) => (
  <div className="assist-strip" role="group" aria-label="Get help">
    <button type="button" className="assist-option" onClick={onCheck}>
      <span className="assist-option-label">Check</span>
      <span className="assist-option-cost">+{costs.check}s</span>
    </button>

    <button
      type="button"
      className="assist-option"
      onClick={onRevealTile}
      disabled={!canRevealTile}
      title={canRevealTile ? undefined : 'Select a square first'}
    >
      {/* "Tile", not "Square": a reveal places the whole tile the selected
          square belongs to, which for a double or triple is more than one
          letter. Labelling it by the square would undersell what it does. */}
      <span className="assist-option-label">Tile</span>
      <span className="assist-option-cost">+{costs.tile}s</span>
    </button>

    <button type="button" className="assist-option" onClick={onRevealAnswer}>
      <span className="assist-option-label">Answer</span>
      <span className="assist-option-cost">+{costs.answer}s</span>
    </button>

    <button type="button" className="assist-option assist-option-giveup" onClick={onGiveUp}>
      <span className="assist-option-label">Give up</span>
    </button>

    <button
      type="button"
      className="assist-close"
      onClick={onClose}
      aria-label="Close help"
    >
      ×
    </button>
  </div>
);

export default AssistStrip;
